/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seat_Types_Card_Change_HintInputs */



/**
* | output |
* | --- |
* | "You can give an empty base seat another type. A more expensive type is charged right away; a cheaper one starts at your next renewal." |
*
* @param {Seat_Types_Card_Change_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const seat_types_card_change_hint = /** @type {((inputs?: Seat_Types_Card_Change_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seat_Types_Card_Change_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Sie können einem freien Basisplatz einen anderen Typ geben. Ein teurerer Typ wird sofort berechnet, ein günstigerer gilt ab Ihrer nächsten Verlängerung.")
	return /** @type {LocalizedString} */ ("You can give an empty base seat another type. A more expensive type is charged right away; a cheaper one starts at your next renewal.")
});